import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'
import { Box, ListItem, Text } from '@domain-group/suit-theme'

import type { PublicationEditionModel } from '@models/types'

const currentDateTime = DateTime.now()

type RenderDateColor = {
  bookingDeadlinePassed: boolean,
  isSelected: boolean,
}

const renderDateColor = (params: RenderDateColor) => {
  const { isSelected, bookingDeadlinePassed } = params

  if (isSelected) return 'white'
  if (bookingDeadlinePassed) return 'faintGrey'

  return 'bodyFontColor'
}

interface PublicationEditionTileProps {
  callbacks: {
    selectPublicationEdition: VoidFunction,
  },
  isSelected: boolean,
  publicationEdition: PublicationEditionModel,
}

const PublicationEditionTile = (props: PublicationEditionTileProps) => {
  const {
    callbacks: { selectPublicationEdition },
    isSelected,
    publicationEdition,
    publicationEdition: {
      publication_date,
      title,
    },
  } = props

  const publicationDate = DateTime.fromFormat(publication_date, 'dd/MM/yyyy')

  const bookingDeadlineRaw = digObject(publicationEdition, 'dates.booking.date_time')
  const bookingDeadline = DateTime.fromFormat(bookingDeadlineRaw, 'dd/MM/yyyy HH:mm')

  const bookingDeadlinePassed = bookingDeadline ? bookingDeadline < currentDateTime : true
  const dateTileTextColour = renderDateColor({ bookingDeadlinePassed, isSelected })

  return (
    <ListItem
      borderColor={isSelected ? 'blue' : 'lineColor'}
      boxProps={{
        border: '1px solid',
        borderRadius: 5,
        paddingY: 'medium',
        marginBottom: 'medium',
      }}
      forceBottomBorder
      onClick={selectPublicationEdition}
    >
      <Box
        borderRight="1px solid"
        borderColor="lineColor"
        flexShrink="0"
        justifyContent="center"
        width="auto"
      >
        <Box
          alignItems="center"
          backgroundColor={isSelected ? 'blue' : 'whiteGrey'}
          borderRadius={5}
          flexDirection="column"
          justifyContent="center"
          padding="medium"
          marginX="medium"
        >
          <Text color={dateTileTextColour} fontWeight="bold" fontSize="small">
            {publicationDate.toFormat('dd')}
          </Text>
          <Text color={dateTileTextColour} fontSize="xxsmall" style={{ letterSpacing: '1px' }}>
            {publicationDate.toFormat('MMM')}
          </Text>
        </Box>
      </Box>

      <Box flexDirection="column" justifyContent="center" marginLeft="medium">
        <Text color={bookingDeadlinePassed ? 'faintGrey' : 'bodyFontColor'} fontSize="small">
          {bookingDeadlinePassed ? `${title} (Booking Passed)` : title}
        </Text>
        <Text color={bookingDeadlinePassed ? 'faintGrey' : 'bodyFontLightColor'} fontSize="xsmall" marginTop="small">
          {/* {`Booking: ${bookingDeadline.toFormat('ddd Do MMM [at] h:mma')}`} */}
          {`Booking: ${bookingDeadline.toFormat("ccc dd LLL yyyy 'at' h:mm a")}`}
        </Text>
      </Box>
    </ListItem>
  )
}

export default PublicationEditionTile
